// 区分环境做代码分割
let _import = null
if (process.env.NODE_ENV === 'production') {
   _import = file => () => import('@/page/' + file + '.vue')
} else { 
   _import = file => require('@/page/' + file + '.vue').default
}
module.exports = _import



// WEBPACK FOOTER //
// ./src/router/_import.js